import LoggerMiddleware from './LoggerMiddleware.js';

const middleware = [LoggerMiddleware];

export { middleware as default, middleware };
